<template>
  <el-dialog
    v-loading="loading"
    class="approve-modal"
    width="90%"
    title="审核认证"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="true"
  >
    <div>
      <div class="approve-info">
        <div class="field">
          <label>申请时间</label><div>{{ approveInfo.createTime | dateTimeFmt }}</div>
        </div>
        <div class="field">
          <label>公司名称</label><div>{{ approveInfo.name }}</div>
        </div>
        <div class="field">
          <label>税号</label><div>{{ approveInfo.identityNo || '--' }}</div>
        </div>
        <div class="field">
          <label>地址</label><div>{{ [approveInfo.province, approveInfo.city, approveInfo.area, approveInfo.address].filter(t => t).join(' ') }}</div>
        </div>
        <div class="field">
          <label>申请人</label><div>{{ approveInfo.userName }}</div>
        </div>
        <div class="field">
          <label>营业执照</label>
          <div v-if="approveInfo.license">
            <el-image :src="approveInfo.license" fit="contain" :preview-src-list="[approveInfo.license]"></el-image>
          </div>
          <div v-else>
            未上传
          </div>
        </div>
        <div class="field">
          <label>门头照片</label>
          <div v-if="approveInfo.images && approveInfo.images.length">
            <el-image :src="approveInfo.images[0]" fit="contain" :preview-src-list="approveInfo.images"></el-image>
          </div>
          <div v-else>
            未上传
          </div>
        </div>
      </div>
      <div class="actions">
        <el-button type="primary" size="small" @click="doApprove(2)">同意</el-button>
        <el-button type="warning" size="small" @click="doApprove(3)">拒绝</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import ModalMixin from '@/mixins/modal/modal-mixin'
import { DoApprove } from '../services'
export default {
  name: 'PackageOrderNowModal',
  mixins: [ModalMixin],
  data () {
    return {
      loading: false,
      approveInfo: {
        id: undefined,
        companyId: undefined,
        createTime: undefined,
        userName: undefined,
        name: undefined,
        identityNo: undefined,
        address: undefined,
        area: undefined,
        city: undefined,
        province: undefined,
        license: undefined,
        images: []
      }
    }
  },
  methods: {
    init (approveInfo) {
      approveInfo.images = approveInfo.image && approveInfo.image.split && approveInfo.image.split(',')
      this.approveInfo = approveInfo
      return this.open()
    },
    async doApprove (state) {
      let reason
      if (state === 3) {
        try {
          reason = await this.getPrompt()
        } catch {
          return
        }
      }
      try {
        this.loading = true
        await DoApprove({ changeId: this.approveInfo.id, approve: state, message: reason })
        this.$message.success('审核成功')
        this.close(true)
      } finally {
        this.loading = false
      }
    },
    getPrompt () {
      return new Promise((resolve, reject) => {
        this.$prompt('请输入拒绝原因', '审核', {
          showInput: true,
          inputPlaceholder: '请输入拒绝原因'
        }).then((val) => {
          resolve(val.value)
        }).catch((ex) => {
          reject(ex)
        })
      })
    }
  }
}
</script>
<style lang="stylus">
.approve-modal
  .el-dialog
    max-width 768px
    .el-dialog__body
      padding-top 0
      max-height 640px
      overflow-x hidden
      overflow-y auto
      .approve-info
        .field
          display flex
          flex-direction row
          label
            flex-shrink 0
            width 70px
            text-align right
            font-weight bold
            &:after
              content: '\ff1a'
          .el-image
            width 48px
            height 48px
            border-radius 6px
      .actions
        text-align right
</style>
